import { LineRecord } from "@/components/FlowSheetEditor/services/modal"
import { PhaseTable } from "../../common/PhaseTable"
import { UnitStatus } from "../../common/Status"
import { IUnitData } from "@/services/project/modal"
import { usePropertySet } from "@/components/FlowSheetEditor/hooks/usePropertySet"
import { useEffect, useState } from "react"
import { ChemicalComponent } from "@/services/chemical-component"
import { numberFixTo } from "../../common/utils"

interface StreamPhaseDataTabProps {
  unitId: string
  data: IUnitData | undefined
}
export const StreamPhaseDataTab = (props: StreamPhaseDataTabProps) => {
  const getPropertySet = usePropertySet()
  const {unitId, data} = props
  const [phaseData, setPhaseData] = useState<any>([])
  const phases = [
    {title: 'Vapor', key: 'vapor'},
    {title: 'Liquid', key: 'liquid'},
  ]
  useEffect(() => {
    let components: ChemicalComponent.Modal[] = []
    if (data?.args.tpps) {
      const propertySet = getPropertySet(data?.args.tpps)
      components = propertySet?.components || []
    }
    const liqData = data?.vars?.LIQ1 || {} as any
    const vapData = data?.vars?.VAP || {} as any
    const componentsData = components.map((item, index) => {
      return {
        name: item.name,
        component: true,
        vapor: numberFixTo(vapData['xi_$1']?.[index], 6) || 0,
        liquid: numberFixTo(liqData['xi_$1']?.[index], 6) || 0
      }
    })
    const tableData = [
      {name: 'Flow [nm3/h]', vapor: numberFixTo(vapData.F), liquid: numberFixTo(liqData.F)},
      {name: 'Composition [mol/mol]', vapor: '-', liquid: '-'},
      ...componentsData,
      {name: 'Enthalpy [kJ/kmol]', vapor: numberFixTo(vapData.h), liquid: numberFixTo(liqData.h)},
      {name: 'Entropy [kJ/kmol-C]', vapor: numberFixTo(vapData.s), liquid: numberFixTo(liqData.s)},
    ]
    setPhaseData(tableData)
  }, [data])
  return <div>
    <PhaseTable phases={phases} data={phaseData}/>
  </div>
}